import { ClientSidebar } from '@ecosystem/newron-client-lib';
import { removeUnsavedFilters } from '@utils/FilterUtils';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { useEffect } from 'react';

export const useResetSelectedFilters = () => {
  const pageConfig = usePageConfig();
  const { pageType, setApplyFilters, setClearFilters } = pageConfig;
  const { expanded: isFilterTrayExpanded } = ClientSidebar.useSidebar();

  useEffect(() => {
    if (isFilterTrayExpanded) return;
    removeUnsavedFilters(pageConfig);
    setApplyFilters(false);
    setClearFilters(false);
  }, [pageType, isFilterTrayExpanded]);
};

export const useUpdateFiltersTrayOpenedAsExpanded = () => {
  const pageConfig = usePageConfig();
  const { toggleFiltersTray } = pageConfig;
  const { expanded: isFilterTrayExpanded } = ClientSidebar.useSidebar();

  useEffect(() => {
    toggleFiltersTray(isFilterTrayExpanded);
  }, [isFilterTrayExpanded]);
};